import axios from 'axios'
const request = axios.create({
    // baseURL: 'http://10.10.3.118:8080', timeout: 10000,
    // baseURL: 'http://10.10.3.199:8090/', timeout: 10000,
    baseURL: 'http://cndatabroker.com/prod-api', timeout: 10000,
})
import {Notification, Message} from 'element-ui'

const errorCode = {
    '401': '认证失败，无法访问系统资源', '403': '当前操作没有权限', '404': '访问资源不存在', 'default': '系统未知错误，请反馈给管理员'
}
request.interceptors.request.use(cofig => {
    // console.log('cofig', cofig)
    return cofig
}, err => {
    Promise.reject(err)
})

// 添加响应拦截器
request.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // console.log('res', res)
    // // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
        return res.data
    }
    if (code === 500) {
        Message({
            message: msg, type: 'error'
        })
        return Promise.reject(new Error(msg))
    } else if (code !== 200) {
        Notification.error({
            title: msg
        })
        return Promise.reject('error')
    } else {
        return res.data
    }
}, error => {
    console.log('err' + error)
    let {message} = error;
    if (message == "Network Error") {
        message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
        message = "系统接口请求超时,请重试";
    } else if (message.includes("Request failed with status code")) {
        message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
        message: message, type: 'error', duration: 5 * 1000
    })
    return Promise.reject(error)
})
export default request

